export const CANONICAL_PETS: Array<{ id: string; label: string }> = [
  { id: 'Chien', label: '🐕 Chien' },
  { id: 'Chat', label: '🐈 Chat' },
  { id: 'Lapin', label: '🐇 Lapin' },
  { id: 'Oiseau', label: '🐦 Oiseau' },
  { id: 'Poisson', label: '🐠 Poisson' },
  { id: 'Rongeur', label: '🐹 Rongeur' },
  { id: 'Reptile', label: '🦎 Reptile' },
];

export const PET_DISPLAY: Record<string, string> = Object.fromEntries(
  CANONICAL_PETS.map((p) => [p.id, p.label])
);

const PET_VARIANTS: Record<string, string> = {
  // Chien
  'dog': 'Chien', 'dogs': 'Chien', 'chien': 'Chien', 'chiens': 'Chien',
  // Chat
  'cat': 'Chat', 'cats': 'Chat', 'chat': 'Chat', 'chats': 'Chat',
  // Lapin
  'rabbit': 'Lapin', 'rabbits': 'Lapin', 'lapin': 'Lapin',
  // Oiseau
  'bird': 'Oiseau', 'birds': 'Oiseau', 'oiseau': 'Oiseau',
  // Poisson
  'fish': 'Poisson', 'poisson': 'Poisson',
  // Rongeur
  'rodent': 'Rongeur', 'hamster': 'Rongeur', 'guinea pig': 'Rongeur', 'rongeur': 'Rongeur',
  // Reptile
  'reptile': 'Reptile', 'snake': 'Reptile', 'lizard': 'Reptile', 'gecko': 'Reptile',
};

/**
 * Normalise un animal : "Dog" → "Chien", "cat" → "Chat", etc.
 * Valeur inconnue retournée telle quelle (nettoyée) pour rester filtrable.
 */
export function normalizePet(input: string): string {
  const cleaned = input.toLowerCase().trim();
  return PET_VARIANTS[cleaned] ?? (input.trim().charAt(0).toUpperCase() + input.trim().slice(1));
}

/**
 * Traite une liste d'animaux bruts et retourne les valeurs canoniques uniques.
 */
export function processInputPets(inputs: string[]): string[] {
  const set = new Set<string>();
  inputs.forEach(p => {
    if (p && typeof p === 'string') set.add(normalizePet(p));
  });
  return Array.from(set).sort();
}
